/**
 * Date formatting utilities to handle timezone issues correctly
 */

/**
 * Format a date string for display, handling timezone correctly
 * Parses date as local date to avoid timezone conversion issues
 * 
 * @param {string} dateStr - Date string in format YYYY-MM-DD
 * @returns {string} Formatted date string (e.g., "Apr 11, 2026")
 */
export const formatDateLocal = (dateStr) => {
  if (!dateStr) return '';
  
  // Parse as local date to avoid timezone issues
  // If dateStr is "2026-04-11", this ensures it stays as April 11
  const [year, month, day] = dateStr.split('-').map(num => parseInt(num, 10));
  const date = new Date(year, month - 1, day);
  
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric',
    timeZone: 'UTC'  // Force UTC to prevent timezone shifts
  });
};

/**
 * Format a date string with full month name
 * 
 * @param {string} dateStr - Date string in format YYYY-MM-DD  
 * @returns {string} Formatted date string (e.g., "April 11, 2026")
 */
export const formatDateLong = (dateStr) => {
  if (!dateStr) return '';
  
  const [year, month, day] = dateStr.split('-').map(num => parseInt(num, 10));
  const date = new Date(year, month - 1, day);
  
  return date.toLocaleDateString('en-US', { 
    month: 'long', 
    day: 'numeric', 
    year: 'numeric',
    timeZone: 'UTC'
  });
};

/**
 * Format a datetime ISO string for display
 * 
 * @param {string} dateTimeStr - ISO datetime string
 * @returns {string} Formatted datetime string
 */
export const formatDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  
  const date = new Date(dateTimeStr);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};
